import { render, staticRenderFns } from "./PartidaequipamientoModals.vue?vue&type=template&id=61258add"
import script from "./PartidaequipamientoModals.vue?vue&type=script&lang=js"
export * from "./PartidaequipamientoModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports